<template>
  <div>
    <NavbarStep /><Compo1 v-if="getStepIndex == 1" />
    <Compo2 v-if="getStepIndex == 2" />
    <Compo3 v-if="getStepIndex == 3" />
    <Compo4 v-if="getStepIndex == 4" />
    <Compo5 v-if="getStepIndex == 5" />
    <Compo6 v-if="getStepIndex >= 6" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavbarStep from "@/components/NavbarStep.vue";
import Compo1 from "@/components/Step1/CompoStep1.vue";
import Compo2 from "@/components/Step2/CompoStep2.vue";
import Compo3 from "@/components/Step3/CompoStep3.vue";
import Compo4 from "@/components/Step4/CompoStep4.vue";
import Compo5 from "@/components/Step5/CompoStep5.vue";
import Compo6 from "@/components/Step6/CompoStep6.vue";
export default {
  components: {
    NavbarStep,
    Compo1,
    Compo2,
    Compo3,
    Compo4,
    Compo5,
    Compo6,
  },
  methods: {},
  computed: {
    ...mapGetters({
      getTesID: "Main/_getAdmissionYear",
      getStepIndex: "Main/_getStepIndex",
    }),
  },
};
</script>

<style></style>
